// Dynamic Cart Recommendations System
// This extends the existing cart drawer functionality to update recommendations in real-time

// Helper function to reinitialize components after DOM updates
function reinitializeComponents(container) {
  // Reinitialize scroll carousel if present
  const carousel = container.querySelector('scroll-carousel');
  if (carousel && carousel.connectedCallback) {
    carousel.connectedCallback();
  }
  
  // Reinitialize product forms
  const productForms = container.querySelectorAll('form[is="product-form"]');
  productForms.forEach(form => {
    if (form.connectedCallback) {
      form.connectedCallback();
    }
  });
  
  // Reinitialize quick buy drawers
  const quickBuyDrawers = container.querySelectorAll('quick-buy-drawer');
  quickBuyDrawers.forEach(drawer => {
    if (drawer.connectedCallback) {
      drawer.connectedCallback();
    }
  });
}

// Function to extract section ID (same as theme.js)
function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

// Function to update recommendations based on current cart
async function updateDynamicRecommendations() {
  try {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.log('Cart drawer not found');
      return;
    }

    // Get the section ID using the same method as theme.js
    const sectionId = extractSectionId(cartDrawer);
    console.log('Cart drawer section ID:', sectionId);
    
    // Fetch updated section with current cart state
    const response = await fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`);
    const sectionHTML = await response.text();
    
    // Parse the response
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHTML, 'text/html');
    const newRecommendations = doc.querySelector('[data-dynamic-recommendations]');
    
    // Find current recommendations in the cart drawer
    const currentRecommendations = cartDrawer.querySelector('[data-dynamic-recommendations]');
    
    console.log('New recommendations found:', !!newRecommendations);
    console.log('Current recommendations found:', !!currentRecommendations);
    
    if (newRecommendations && currentRecommendations) {
      console.log('Updating existing recommendations');
      // Update existing recommendations with smooth transition
      currentRecommendations.style.transition = 'opacity 0.3s ease';
      currentRecommendations.style.opacity = '0';
      
      setTimeout(() => {
        currentRecommendations.innerHTML = newRecommendations.innerHTML;
        currentRecommendations.style.opacity = '1';
        reinitializeComponents(currentRecommendations);
        console.log('Recommendations updated successfully');
      }, 300);
      
    } else if (newRecommendations && !currentRecommendations) {
      console.log('Adding new recommendations');
      // Add recommendations if they don't exist
      const cartSplit = cartDrawer.querySelector('.cart-split');
      if (cartSplit) {
        const recommendationsElement = newRecommendations.cloneNode(true);
        cartSplit.appendChild(recommendationsElement);
        reinitializeComponents(recommendationsElement);
        console.log('New recommendations added successfully');
      }
      
    } else if (!newRecommendations && currentRecommendations) {
      console.log('Removing recommendations');
      // Remove recommendations if they shouldn't exist
      currentRecommendations.style.transition = 'opacity 0.3s ease';
      currentRecommendations.style.opacity = '0';
      setTimeout(() => {
        currentRecommendations.remove();
        console.log('Recommendations removed successfully');
      }, 300);
    } else {
      console.log('No recommendations update needed');
    }
  } catch (error) {
    console.error('Error updating dynamic cart recommendations:', error);
  }
}

// Listen for cart changes and update recommendations
document.addEventListener('cart:change', (event) => {
  console.log('Cart change detected, updating recommendations...', event.detail);
  // Wait for the main cart drawer update to complete first
  setTimeout(updateDynamicRecommendations, 1300); // Wait longer than the theme's setTimeout
});

document.addEventListener('variant:add', (event) => {
  console.log('Variant added, updating recommendations...', event.detail);
  // Update recommendations when new items are added immediately since it's a new item
  setTimeout(updateDynamicRecommendations, 50);
});

// Initial setup when page loads
document.addEventListener('DOMContentLoaded', () => {
  // Update recommendations if cart drawer exists and has items
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    updateDynamicRecommendations();
  }
}); 